// TODO (websdk-ms-1-phase-versus): Implement device info

export function getDeviceInfo() {
  const deviceInfo = {
    id: '3C18190D-A6C0-43A7-9BDC-F20C1C8ED653',
    wifi: true,
    rooted: false,
    gps: true,
    network_location: true,
    location_services: true,
    mock_location: false,
  };

  const playerMetadata = {
    device: 'x86_64 (Simulator (64-bit))',
    replayProperties: {
      port: 1935,
      scale: 1,
      networkProtocol: 'tcp',
      streamingProtocol: 'rtsp/rtp',
      shareBaseUrl: 'https://replay.staging.skillz.com/view/',
      cdnBaseUrl: 'https://s3.amazonaws.com/skillz-replay-stage/',
      login: 'skillz-ios-publisher',
      cdnFileExtension: '.mp4',
      bitrate: 256000,
      host: 'stream.staging.skillz.com',
      applicationName: 'in',
      keyframeInterval: 3,
      cdnNoReplayName: 'no_replay_found',
      packetSize: '256',
      codec: 'h.264',
      framerate: 24,
    },
    radio: '(none)',
    isWifiConnected: true,
    hasGeoLocation: true,
    os_version: '17.4',
    carrier: '(null) ((null))',
    isReplayEnabled: 1,
  };

  // const deviceInfo = {
  //   id: "123",
  //   wifi: true,
  //   rooted: false,
  //   gps: true,
  //   network_location: true,
  //   location_services: true,
  //   mock_location: false,
  // };
  //
  // const playerMetadata = {
  //   device: "iPhone",
  //   replayProperties: {
  //     port: 1935,
  //     scale: 1,
  //     networkProtocol: "rtmp",
  //     streamingProtocol: "rtmp",
  //     shareBaseUrl: "http://localhost:8080",
  //     cdnBaseUrl: "http://localhost:8080",
  //     login: "admin",
  //     cdnFileExtension: "flv",
  //     bitrate: 500,
  //     host: "localhost",
  //     applicationName: "live",
  //     keyframeInterval: 60,
  //     cdnNoReplayName: "live",
  //     packetSize: "medium",
  //     codec: "h264",
  //     framerate: 30,
  //   },
  //   radio: "wifi",
  //   isWifiConnected: true,
  //   hasGeoLocation: true,
  //   os_version: "1.0.0",
  //   carrier: "AT&T",
  //   isReplayEnabled: 1,
  // };

  return {deviceInfo, playerMetadata};
}
